import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { TokenService } from "../services/auth/token.service";

export const AuthGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const tokenService = inject(TokenService);
    
    if (tokenService.getToken()) {
        return true;
    }
    router.navigate(['/login']);
    return false;
};